import React from 'react';
import { Layout } from 'antd';
import { withTranslation } from 'react-i18next';
import { NAMESPACES } from '../../i18n';
import PropTypes from 'prop-types';
import { ExportingCertificates as ExportingCertificatesContainer } from '../../containers';

class ExportingCertificates extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        accountId: PropTypes.string.isRequired,
      }),
    }),
  };

  render() {
    const {
      match: {
        params: { accountId },
      },
      t,
      accounts,
    } = this.props;

    return (
      <Layout className="main-container">
        <h1>{t('titleExport')}</h1>
        <ExportingCertificatesContainer
          t={t}
          accountId={accountId}
          accounts={accounts}
        />
      </Layout>
    );
  }
}

export default withTranslation(NAMESPACES.transferringCertificates)(
  ExportingCertificates
);
